import React from "react";
import {
  Calendar,
  Clock,
  MapPin,
  Mail,
  User,
  Mic,
  CalendarDays,
} from "lucide-react";
import foto1 from "../img/foto1.jpeg";
import foto2 from "../img/foto2.jpg";
import foto3 from "../img/foto3.jpeg";
import mary from "../img/mary.jpeg";
import ivan_bermeo from "../img/ivan_bermeo.jpeg";
import juan_diego from "../img/juan.jpeg";

export default function EventoDebateUTPL() {
  return (
    <div className="bg-slate-100 py-24 px-6">
      <div className="max-w-5xl mx-auto my-8 font-sans overflow-hidden bg-white rounded-2xl border border-slate-100 shadow-xl">
        {/* Encabezado Principal con los colores institucionales UTPL */}
        <div className="relative bg-[#004270] text-white p-8 md:p-12 overflow-hidden">
          <div className="relative z-10 max-w-3xl">
            <p className="inline-flex items-center px-3 py-1 text-xs mb-6 font-medium text-[#004270] bg-amber-100 rounded-full dark:bg-indigo-950 dark:text-indigo-300">
              Debate
            </p>
            <h2 className="text-white">
              Debate | 50 años ofertando MAD: transformando vidas y contextos
            </h2>
            <p className=" text-white">
              Un espacio para reflexionar sobre el impacto de la Modalidad
              Abierta y a Distancia en la formación de profesionales y la
              transformación de vidas durante cinco décadas de trayectoria.
            </p>
          </div>
        </div>

        {/* Grid de Información y Ponentes */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-0">
          {/* Panel Izquierdo: Detalles del Evento (Fecha, Hora, Lugar) */}
          <div className="lg:col-span-4 bg-slate-50 p-8 border-b lg:border-b-0 lg:border-r border-slate-100 flex flex-col justify-between">
            <div className="space-y-6">
              <h3>Detalles del evento</h3>

              {/* Fecha */}
              <div className="flex items-start gap-4">
                <div className="p-3 bg-white rounded-xl shadow-sm text-[#002f6c] border border-slate-100">
                  <Calendar className="w-6 h-6 text-[#002f6c]" />
                </div>
                <div>
                  <p className="text-xs text-slate-500 font-medium uppercase">
                    Fecha
                  </p>
                  <p>Viernes, 04 de septiembre de 2026</p>
                </div>
              </div>

              {/* Hora */}
              <div className="flex items-start gap-4">
                <div className="p-3 bg-white rounded-xl shadow-sm text-[#002f6c] border border-slate-100">
                  <Clock className="w-6 h-6 text-[#002f6c]" />
                </div>
                <div>
                  <p className="text-xs text-slate-500 font-medium uppercase">
                    Hora
                  </p>
                  <p>17:00 (ECT)</p>
                </div>
              </div>

              {/* Lugar */}
              <div className="flex items-start gap-4">
                <div className="p-3 bg-white rounded-xl shadow-sm text-[#002f6c] border border-slate-100">
                  <MapPin className="w-6 h-6 text-[#002f6c]" />
                </div>
                <div>
                  <p className="text-xs text-slate-500 font-medium uppercase">
                    Lugar
                  </p>
                  <p>Centro de Convenciones UTPL</p>
                </div>
              </div>
            </div>

            {/* Responsable del Debate */}
            <div className="mt-10 pt-6 border-t border-slate-200">
              <p className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-3">
                Responsable
              </p>
              <div className="bg-white p-4 rounded-xl border border-slate-100 shadow-sm">
                <p>
                  <b>Santiago Pérez Samaniego</b>
                </p>
                <p>
                  Director de la carrera en Ciencias Políticas y Relaciones
                  Internacionales
                </p>
                <a
                  href="mailto:saperez1@utpl.edu.ec"
                  className="inline-flex items-center gap-1.5 mt-3 text-xs font-semibold text-[#002f6c] hover:text-[#f2b705] transition-colors"
                >
                  <Mail className="w-3.5 h-3.5" />
                  saperez1@utpl.edu.ec
                </a>
              </div>
            </div>
          </div>

          {/* Panel Derecho: Ponentes y Moderador */}
          <div className="lg:col-span-8 p-8 md:p-10 space-y-8">
            {/* Sección Ponentes */}
            <div>
              <h3>Ponentes Invitados</h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Ponente 1 */}
                <div className="flex gap-4 items-start p-4 rounded-xl hover:bg-slate-50 transition-all duration-200 border border-transparent hover:border-slate-100">
                  <div className="w-16 h-16 rounded-full bg-slate-200 flex-shrink-0 flex items-center justify-center text-slate-400 overflow-hidden border-2 border-slate-100">
                    {/* Reemplazar src con la ruta real de (FOTO 1) */}
                    <img
                      src={foto1}
                      alt="Xavier Pimentel"
                      className="w-full h-full object-cover onError={(e) => e.target.style.display = 'none'}"
                    />
                  </div>
                  <div>
                    <h4>Xavier Pimentel</h4>
                    <p>
                      Actor, director, productor y guionista ecuatoriano.
                      Estudiante de la Carrera de Ciencias Políticas y
                      Relaciones Internacionales UTPL.
                    </p>
                  </div>
                </div>

                {/* Ponente 2 */}
                <div className="flex gap-4 items-start p-4 rounded-xl hover:bg-slate-50 transition-all duration-200 border border-transparent hover:border-slate-100">
                  <div className="w-16 h-16 rounded-full bg-slate-200 flex-shrink-0 flex items-center justify-center text-slate-400 overflow-hidden border-2 border-slate-100">
                    {/* Reemplazar src con la ruta real de (FOTO 2) */}
                    <img
                      src={foto2}
                      alt="Ariana Rios"
                      className="w-full h-full object-cover onError={(e) => e.target.style.display = 'none'}"
                    />
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 flex-wrap">
                      <h4>Ariana Rios</h4>
                      <span className="bg-blue-50 text-[#002f6c] px-1.5 py-0.5 rounded text-[10px] font-bold border border-blue-100">
                        Alumni
                      </span>
                    </div>
                    <p>
                      Oficial de Investigaciones en la Oficina de Auditoría
                      Interna e Investigaciones (OIAI) de UNICEF.
                    </p>
                  </div>
                </div>

                {/* Ponente 4 */}
                <div className="flex gap-4 items-start p-4 rounded-xl hover:bg-slate-50 transition-all duration-200 border border-transparent hover:border-slate-100">
                  <div className="w-16 h-16 rounded-full bg-slate-200 flex-shrink-0 flex items-center justify-center text-slate-400 overflow-hidden border-2 border-slate-100">
                    {/* Reemplazar src con la ruta real de (FOTO 2) */}
                    <img
                      src={mary}
                      alt="utpl"
                      className="w-full h-full object-cover onError={(e) => e.target.style.display = 'none'}"
                    />
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 flex-wrap">
                      <h4>Mary Morocho </h4>
                      <p>Docente UTPL</p>
                    </div>
                  </div>
                </div>

                {/* Ponente 5 */}
                <div className="flex gap-4 items-start p-4 rounded-xl hover:bg-slate-50 transition-all duration-200 border border-transparent hover:border-slate-100">
                  <div className="w-16 h-16 rounded-full bg-slate-200 flex-shrink-0 flex items-center justify-center text-slate-400 overflow-hidden border-2 border-slate-100">
                    {/* Reemplazar src con la ruta real de (FOTO 2) */}
                    <img
                      src={juan_diego}
                      alt="utpl"
                      className="w-full h-full object-cover onError={(e) => e.target.style.display = 'none'}"
                    />
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 flex-wrap">
                      <h4>Juan Diego Febres </h4>
                      <p>Docente UTPL</p>
                    </div>
                  </div>
                </div>

                <div className="flex gap-4 items-start p-4 rounded-xl hover:bg-slate-50 transition-all duration-200 border border-transparent hover:border-slate-100">
                  <div className="w-16 h-16 rounded-full bg-slate-200 flex-shrink-0 flex items-center justify-center text-slate-400 overflow-hidden border-2 border-slate-100">
                    <img
                      src={ivan_bermeo}
                      alt="utpl"
                      className="w-full h-full object-cover onError={(e) => e.target.style.display = 'none'}"
                    />
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 flex-wrap">
                      <h4>Iván Bermeo Beltrán  </h4>
                      <p>CEO y socio fundador de INDULOJA CIA. LTDA</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Sección Moderador */}
            <div className="pt-6 border-t border-slate-100">
              <h3>Moderador</h3>

              {/* Moderador Único */}
              <div className="flex gap-4 items-start p-4 rounded-xl bg-slate-50/50 border border-slate-100">
                <div className="w-16 h-16 rounded-full bg-slate-200 flex-shrink-0 flex items-center justify-center text-slate-400 overflow-hidden border-2 border-slate-100">
                  {/* Reemplazar src con la ruta real de (FOTO 3) */}
                  <img
                    src={foto3}
                    alt="Fabricio Vela"
                    className="w-full h-full object-cover onError={(e) => e.target.style.display = 'none'}"
                  />
                </div>
                <div>
                  <h4>Fabricio Vela</h4>
                  <p>
                    Director del noticiero “A Primera Hora” en Radio Armónica
                    FM. Co-fundador del portal de noticias “Primera Plana”.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
    </div>
  );
}
